import * as React from 'react';
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import { useIntl, Link } from 'gatsby-plugin-react-intl'
import { getActiveMonth, useSelectedMonthContext, getMonthIndexFromName } from 'context/SelectedMonthContext';
import { DestinationMonthPicker } from "./DestinationMonthPicker";
import Arrow from 'images/ico_arrow_white.svg'
import { Region } from 'templates/fragments/region';
import { Country, CountryBase } from 'templates/fragments/country';
import getLocationPath from 'services/getLocationPath';
import firstCapital from 'services/firstCapitalCase';
export const DestinationPageHero = ({ placeWithPreposition,
    bgImage,
    slug,
    month,
    header,
    region = null,
    country = null,
    continent = null,
    doNotShowMonthPicker = false
}: {
    placeWithPreposition: string,
        bgImage: ImageDataLike,
    header: string,
    slug: string,
    month?: string,
    region?: Region,
    country?: CountryBase
    continent?: string
    doNotShowMonthPicker?: boolean
}) => {
    const intl = useIntl()
    const [months, dispatch] = useSelectedMonthContext()
    const activeMonth = getActiveMonth(months)
    const monthIndex = getMonthIndexFromName(activeMonth.name);
    const monthName = intl.formatMessage({ id: `common.months.${activeMonth.name}` })
    const breakpoints = useBreakpoint()
    const isMobile = breakpoints.sm
    const isDesktop = !breakpoints.sm
    React.useEffect(() => {
        if (month) {
            dispatch({ type: 'SET_ACTIVE_MONTH', selectedMonthName: month })
        }
    }, []);

    const isCountry = !!country;
    country = country || region?.country;
    const continentName = continent || country?.continent;
    return (<div className="destination__hero">
        <GatsbyImage alt="" image={getImage(bgImage)} className="image--fit_cover destination__hero__image" />

        <div className="breadcrumbs">

            {isMobile && (<p className="breadcrumbs__item--mobile">
                {continent && <Link to="/"><img alt="" src={Arrow}
                    className="breadcrumbs__item--arrow" /><span>{intl.formatMessage({ id: `common.home` })}</span>
                </Link>}
                {(isCountry || region?.isCountry) && <Link to={`/${continentName}-weather-climate/`}><img alt="" src={Arrow}
                    className="breadcrumbs__item--arrow" /><span>{intl.formatMessage({ id: `common.continents.${continentName}` })}</span>
                </Link>}
                {(region && !region.isCountry) && <Link to={getLocationPath({ location: country, isCountryInstance: true, monthIndex: monthIndex })}><img alt="" src={Arrow}
                    className="breadcrumbs__item--arrow" /><span>{country.name}</span>
                </Link>}
            </p>)}
            {isDesktop && (<ul className="breadcrumbs__list">
                <li className="breadcrumbs__list__item"><Link to="/">Home</Link></li>
                <li className={`breadcrumbs__list__item` + (continent ? '--active' : '')}>
                    <Link to={`/${continentName}-weather-climate/`}>{intl.formatMessage({ id: `common.continents.${continentName}` })}</Link>
                </li>
                {!continent && <li className={`breadcrumbs__list__item` + ((isCountry || region?.isCountry) ? '--active' : '')}>
                    <Link to={getLocationPath({ location: country, isCountryInstance: true, monthIndex: monthIndex })}>{country.name}</Link>
                </li>}
                {region && !region.isCountry && <li className={`breadcrumbs__list__item` + (region ? '--active' : '')}>
                    <Link to={getLocationPath({ location: region, isCountryInstance: false, monthIndex: monthIndex })}>{region.slugName || region.name}</Link>
                </li>}
            </ul>)}
        </div>
        <h1 className="destination__title">{`${header}`}</h1>
        {!doNotShowMonthPicker && <DestinationMonthPicker slug={slug} />}
    </div>)
}

